/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchManagementAwsResourceDetails {
    getFixupPrototypeFunction() { return PatchManagementAwsResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<PatchManagementAwsResourceDetails>): PatchManagementAwsResourceDetails {
        let obj = Object.assign(new PatchManagementAwsResourceDetails(), model);
        PatchManagementAwsResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchManagementAwsResourceDetails>): PatchManagementAwsResourceDetails {
        if (!model) return null;
        return PatchManagementAwsResourceDetails.newInstance(<PatchManagementAwsResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchManagementAwsResourceDetails) {
        if (!obj) return;

        models.PatchManagementAwsResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchManagementAwsResourceDetails): boolean {
        Object.setPrototypeOf(obj, PatchManagementAwsResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.statistics) {
            models.PatchManagementAwsStatisticsDetails.fixupPrototype(this.statistics);
        }
        if (this.platform) {
            models.PatchManagementAwsPlatformDetails.fixupPrototype(this.platform);
        }
        if (this.patch_group_baseline_data) {
            models.PatchManagementAwsPatchGroupBaselineData.fixupPrototype(this.patch_group_baseline_data);
        }
    }

    /**
     * Type of patching operation that was performed
     */
    operation: string;

    /**
     * ID of the patch baseline snapshot
     */
    snapshot_id: string;

    /**
     * Compliance status for the resource
     */
    status: string;

    /**
     * The fully qualified host name of the managed node
     */
    computer_name: string;

    /**
     * Reboot option specified in the patch baseline
     */
    reboot_option: string;

    /**
     * AWS statistics details
     */
    statistics: models.PatchManagementAwsStatisticsDetails;

    /**
     * Platform details
     */
    platform: models.PatchManagementAwsPlatformDetails;

    /**
     * Patch group details
     */
    patch_group_baseline_data: models.PatchManagementAwsPatchGroupBaselineData;

}
